(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'adminMenu',
            [
                'CHROME',
                AdminMenuFactory
            ]
        );

    // Factory Method
    function AdminMenuFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.MENU.ADMIN + CHROME.POSTFIX
    };

    }
})();



